import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ProgramClinicalSiteDetails.module.scss';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import ProgramClinicalSitesTable from './ProgramClinicalSitesTable';
import ViewAllClinicalSitesModal from './ViewAllClinicalSitesModal';
import AddClinicalSitesModal from './AddClinicalSitesModal';
import { useAuth } from '../../../contexts/AuthContext';

const ProgramClinicalSiteDetails = ({ clinicalSites = [], programId, programTitle, onRefresh }) => {
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const { role, can } = useAuth();
    const canAddClinicalSites = role !== 'Program Coordinator' || can('canAddClinicalSites');

    const handleOpenAddModal = () => {
        setIsViewModalOpen(false);
        setIsAddModalOpen(true);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>Clinical Sites</h2>
                {canAddClinicalSites && (
                    <Button
                        label={
                            <div className={styles.cta}>
                                <Icon name="plus" />
                                Add Clinical Site
                            </div>
                        }
                        variant="primary-light"
                        size="small"
                        onClick={handleOpenAddModal}
                    />
                )}
            </div>
            
            <div className={styles.tableWrapper}>
                <ProgramClinicalSitesTable clinicalSites={clinicalSites} />
            </div>

            <div className={styles.footer}>
                <Button 
                    label={
                        <div className={styles.cta}>
                            <Icon name="arrow-up-right" />
                            View All Clinical Sites
                        </div>
                    }
                    variant="primary-light"
                    size="small"
                    onClick={() => setIsViewModalOpen(true)}
                />
            </div>

            <ViewAllClinicalSitesModal 
                isOpen={isViewModalOpen} 
                onClose={() => setIsViewModalOpen(false)} 
                programId={programId}
                programTitle={programTitle}
                onAddSitesClick={handleOpenAddModal}
            />

            <AddClinicalSitesModal 
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
                programId={programId}
                onSuccess={onRefresh}
            />
        </div>
    );
};

ProgramClinicalSiteDetails.propTypes = {
  clinicalSites: PropTypes.array,
  programId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  programTitle: PropTypes.string,
  onRefresh: PropTypes.func
};

export default ProgramClinicalSiteDetails;
